import type { FlowContext } from "../builder/flow-context";
import type { FormProps } from "../builder/webhook-form";
import { ShowMyTicketsForm, ShowTicketFormForm, TicketIntakeForm } from "./facing-ticket-forms";
import { CheckOrderStatusForm, CreateOrderForm, LookupAssetForm, LookupCatalogueForm, ScheduleVisitForm, ShowCatalogueForm, ShowOrderStatusForm } from "./orders-forms";
import { AddTicketNoteForm, ApplyTicketSlaForm, AssignTicketForm, LinkTicketForm, NotifyContactForm, ReplyToTicketForm, RequestCsatForm } from "./people-forms";
import type { ServiceStep } from "./service-types";
import { CreateTicketForm, RouteTicketForm, SetTicketStateForm, UpdateTicketForm } from "./ticket-forms";

/** The form for any Service Desk step: the ones that act in the background (tickets, assets and visits, the catalogue and orders) and the six the client sees. */
export function ServiceStepForm({ step, disabled, onChange, ...flow }: FormProps<ServiceStep> & FlowContext) {
  const edit = onChange;
  const common = { disabled, paths: flow.paths, canAddPath: flow.canAddPath, facing: flow.facing };
  switch (step.type) {
    case "create_ticket":
      return <CreateTicketForm step={step} onChange={edit} {...common} />;
    case "update_ticket":
      return <UpdateTicketForm step={step} onChange={edit} {...common} />;
    case "set_ticket_state":
      return <SetTicketStateForm step={step} onChange={edit} {...common} />;
    case "route_ticket":
      return <RouteTicketForm step={step} onChange={edit} {...common} />;
    case "assign_ticket":
      return <AssignTicketForm step={step} onChange={edit} {...common} />;
    case "add_ticket_note":
      return <AddTicketNoteForm step={step} disabled={disabled} onChange={edit} />;
    case "reply_to_ticket":
      return <ReplyToTicketForm step={step} disabled={disabled} onChange={edit} />;
    case "notify_contact":
      return <NotifyContactForm step={step} onChange={edit} {...common} />;
    case "link_ticket":
      return <LinkTicketForm step={step} disabled={disabled} onChange={edit} />;
    case "apply_ticket_sla":
      return <ApplyTicketSlaForm step={step} disabled={disabled} onChange={edit} />;
    case "request_csat":
      return <RequestCsatForm step={step} onChange={edit} {...common} />;
    case "ticket_intake":
      return <TicketIntakeForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
    case "show_ticket_form":
      return <ShowTicketFormForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
    case "show_my_tickets":
      return <ShowMyTicketsForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
    case "lookup_asset":
      return <LookupAssetForm step={step} onChange={edit} {...common} />;
    case "schedule_visit":
      return <ScheduleVisitForm step={step} onChange={edit} {...common} />;
    case "lookup_catalogue":
      return <LookupCatalogueForm step={step} onChange={edit} {...common} />;
    case "check_order_status":
      return <CheckOrderStatusForm step={step} onChange={edit} {...common} />;
    case "show_catalogue":
      return <ShowCatalogueForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
    case "create_order":
      return <CreateOrderForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
    case "show_order_status":
      return <ShowOrderStatusForm step={step} disabled={disabled} onChange={edit} paths={flow.paths} canAddPath={flow.canAddPath} />;
  }
}
